import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
import Workarea from "./Workarea";
import { getGame } from "../redux/asyncThunk/userActions";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { userSlice } from "../redux/user/userSlice";
import { firstSceneNodes } from "./nodes/FirstSceneNode";

const { addNode } = userSlice;

export default function Game() {
  const [gameData, setGameData] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedGameId = useSelector((state) => state.user?.selectedGameId);
  const status = useSelector((state) => state.user?.status);
  const game = useSelector((state) => state.user.game);

  useEffect(() => {
    if (selectedGameId) {
      dispatch(getGame({ gameId: selectedGameId }));
    } else {
      navigate("/main", { replace: true });
    }
  }, [dispatch, navigate, selectedGameId]);

  useEffect(() => {
    if (game) {
      if (game.nodes?.length < 1) {
        dispatch(addNode({ data: [...firstSceneNodes] }));
      } else {
        setGameData(game);
      }
    }
  }, [dispatch, game]);

  return (
    <div style={{ width: "100%" }}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <h1>{gameData?.title}</h1>
      </div>
      <div style={{ width: "inherit", height: "85vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "10px 0",
          }}
        >
          <div>
            <Divider sx={{ width: "300px" }} />
          </div>
        </div>

        {status === "loading" ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "95vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>{gameData ? <Workarea game={gameData} /> : null}</>
        )}
      </div>
    </div>
  );
}
